import { render, staticRenderFns } from "./o-wrapper-overlap.vue?vue&type=template&id=3789cf80&scoped=true"
import script from "./o-wrapper-overlap.vue?vue&type=script&lang=js"
export * from "./o-wrapper-overlap.vue?vue&type=script&lang=js"
import style0 from "./o-wrapper-overlap.vue?vue&type=style&index=0&id=3789cf80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3789cf80",
  null
  
)

export default component.exports